export default __webpack_public_path__ + "static/media/services_creatives.56dcb9da.jpg";